import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { StatCard } from "./StatCard";
import { ADMIN } from "../../constants/testIds";

export const AnalyticsDashboard = ({ data, loading }) => {
  return (
    <div data-testid={ADMIN.dashboardContainer} className="space-y-6">
      <div data-testid={ADMIN.dashboardContainer + "-cards"} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testId={ADMIN.uniqueVisitorsCard} label="Unique Visitors" value={data?.unique_visitors || 0} accent="indigo" sparkline={data?.traffic_trend} />
        <StatCard testId={ADMIN.avgDurationCard} label="Avg Session Duration" value={(data?.avg_session_duration_seconds || 0) / 60} decimals={1} suffix="m" accent="emerald" />
        <StatCard testId={ADMIN.completionCard} label="Completion Rate" value={data?.completion_rate || 0} decimals={1} suffix="%" accent="amber" />
        <StatCard testId="listen-sessions-card" label="Listen Sessions" value={data?.total_listen_sessions || 0} accent="rose" />
      </div>

      <div className="p-5 sm:p-6 rounded-xl border border-slate-800 bg-slate-900/80 backdrop-blur-md">
        <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Traffic Trend</h3>
        <div data-testid={ADMIN.trafficChart} style={{ width: "100%", height: 260 }}>
          {loading ? (
            <p className="text-sm text-slate-500">Loading…</p>
          ) : (
            <ResponsiveContainer minWidth={200} minHeight={150}>
              <AreaChart data={data?.traffic_trend || []}>
                <defs>
                  <linearGradient id="trafficGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#38BDF8" stopOpacity={0.5} />
                    <stop offset="95%" stopColor="#38BDF8" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
                <XAxis dataKey="date" stroke="#64748B" fontSize={11} />
                <YAxis stroke="#64748B" fontSize={11} allowDecimals={false} />
                <Tooltip contentStyle={{ background: "#0F172A", border: "1px solid #334155" }} />
                <Area type="monotone" dataKey="count" stroke="#38BDF8" fill="url(#trafficGradient)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
};
